import { SwiperCarousel } from '@/components/molecules/SwiperCarousel/SwiperCarousel';
import { BlogListingLink } from '@/components/organisms/BlogListingLink';
import { BlogPreview } from '@/types/blog';
import { FC, useState } from 'react';

interface LatestNewsSectionProps {
  posts: BlogPreview[];
}

export const LatestNewsSection: FC<LatestNewsSectionProps> = ({ posts }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <section className="flex flex-col gap-xl px-l py-xl lg:px-[64px] lg:py-[40px]">
      <h3 className="text-h3SemiBold">Latest news</h3>
      <div className="hidden gap-xl md:grid md:grid-cols-2 md:gap-xl ml:flex ml:h-[490px] ml:flex-row">
        {posts.map((blog) => (
          <div key={blog.id} className="h-full flex-1">
            <BlogListingLink blog={blog} showExcerpt titleVariant="large" />
          </div>
        ))}
      </div>
      <div className="flex md:hidden">
        <SwiperCarousel
          slidesPerView={1}
          spaceBetween={10}
          loop
          slides={posts.map((blog) => (
            <div key={blog.id} className="h-full flex-1">
              <BlogListingLink
                key={blog.id}
                blog={blog}
                showExcerpt
                titleVariant="large"
              />
            </div>
          ))}
          selectedIndex={currentIndex}
          updateCurrentIndex={setCurrentIndex}
          centeredSlides
          navigation={false}
          allowTouchMove
          dots
          dotAmount={posts.length}
        />
      </div>
    </section>
  );
};
